export const truncateStyles = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const folderTreeStyles = {
  width: '100%',
  maxHeight: '70vh',
  overflowY: 'auto',

  '& .MuiTreeItem-content': {
    py: '9px',
    pr: '16px',

    '&.Mui-selected, &.Mui-focused': {
      borderRadius: 0,
      backgroundColor: '#140F4B1F !important',

      '&[data-selected="false"]': {
        fontWeight: 400,
        backgroundColor: 'transparent !important',
      },
    },
  },
};

export const folderTreeItemStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  height: 40,
};

export const filesListContainerStyles = (dragActive: boolean) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: dragActive ? 'electricBlue10.main' : 'auto',
  border: dragActive ? '2px dashed #140f4b' : '2px solid #0000001A',
  borderLeft: dragActive ? 'auto' : 'none',
  width: '60%',
});

export const filesListHeaderStyles = {
  borderBottom: '2px solid #0000001A',
  p: '8px 16px',
  display: 'flex',
};

export const filesListBlockStyles = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxHeight: '70vh',
  overflowY: 'auto',
};

export const filesListNameItemStyles = {
  display: 'flex',
  height: '54px',
  alignItems: 'center',
  gap: 1,
  flex: 3,
  fontWeight: 600,
};

export const filesListCheckboxStyles = {
  p: 0,
  mr: '16px',
  ml: '4px',

  '& svg': {
    width: '20px',
    height: '20px',
  },
};

export const folderTreeStackStyles = {
  width: '100%',
  backgroundColor: '#fff',
  borderRadius: '4px',
  p: 2,
  mt: 2,
  minHeight: '55vh',
};

export const folderTreeBlockStyles = {
  display: 'flex',
  minHeight: '40vh',
};

export const folderTreeContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  border: '2px solid #0000001A',
  width: '40%',
};

export const folderTreeHeaderStyles = {
  borderBottom: '2px solid #0000001A',
  p: '12px',
  fontWeight: 600,
};

export const filesListSelectedItemsContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  backgroundColor: '#0000001A',
  p: '8px',
};

export const outlinedIconButtonStyles = {
  border: '1px solid #1010EB',
  color: 'electricBlue.main',
};

export const folderTreeItemActionsBlockStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
};

export const storageStatBlockStyles = {
  padding: '16px',
  border: '1px solid #0000004D',
  borderRadius: '8px',
  width: '100%',
};

export const storageStatIconStyles = { width: 28, height: 28, color: '#0000008C' };

export const folderNameTypographyStyles = (isSelectedFolder: boolean) => ({
  ...truncateStyles,
  fontSize: '1.8rem',
  fontWeight: isSelectedFolder ? 600 : 400,
});

export const outlinedDeleteButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  px: '8px',
};

export const fileNameStyles = {
  ...truncateStyles,
  fontWeight: 600,
};

export const fileListItemStyles = {
  p: 0,
};

export const fileListItemContainerStyles = {
  alignItems: 'center',
  height: '78px',
  width: '100%',
};

export const fileListItemCheckboxGridStyles = {
  display: 'flex',
  alignItems: 'center',
  pl: '16px',
};

export const fileListItemNameGridStyles = {
  display: 'flex',
  alignItems: 'center',
};

export const fileListItemDocumentIconStyles = {
  width: 24,
  height: 24,
  marginRight: '8px',
};

export const fileListItemMoreButtonGridStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  pr: '8px',
};

export const fileListItemMoreButtonStyles = {
  color: 'electricBlue.main',
  textTransform: 'capitalize' as const,
};

export const fileListItemVerticalDotsIconStyles = {
  marginLeft: '1rem',
};

export const fileListItemMenuElevation = 1;

export const fileListItemMenuItemStyles = {
  color: 'electricBlue.main',
};
